module.exports = __webpack_public_path__ + "static/media/fs_truman-regular-webfont.23a2481f.woff2";